import Axios, { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage, ErrorType, BaseResponseCore } from "./BaseResponse";
 
import SessionHelper from "./SessionHelper";
export default class BaseApi {

  //protected static BaseUrl: String = "https://karo.club/api/api/web/";
  protected static BaseUrl: String = "http://ipswebadmin-001-site2.dtempurl.com/api/api/";
  // protected static BaseUrl: String = "http://localhost:30605/api/Web/";

  protected static BasePostRequestAsync<T>(url: string, model: any): Promise<BaseResponseCore<T>> {
    return this.BasePostRequestInternalAsync<T>(url, model, false);
  }

  protected static BasePostRequestWithFileAsync<T>(url: string, model: any): Promise<BaseResponseCore<T>> {
    return this.BasePostRequestInternalAsync<T>(url, model, true);
  }

  protected static BasePostRequestInternalAsync<T>(url: string, model: any, IsWithFile: boolean): Promise<BaseResponseCore<T>> {

    return new Promise((resolve) => {

      var formData = model;
      var config = undefined;
      var finalApiUrl = this.BaseUrl + url
      var apiAuthorization= SessionHelper.GetSession()?.ApiSessionToken;

      config = {
        headers: {
          'Authorization': `Bearer ${apiAuthorization}`,
          'Accept' : 'application/json',
          'content-type': 'application/json'
        }
      }

      if (IsWithFile) {
        formData = this.GetFormDataFromModel(model);
        config.headers["content-type"]='multipart/form-data'         
      }


      console.log(finalApiUrl)
      console.log(formData)

      Axios.post(finalApiUrl, formData, config).then(res => {
        var res2 = this.ProcessSucessAsync<T>(res);
        console.log(res2)
        resolve(res2)
      }).catch(error => {
        var res2 = this.ProcessFailureAsync<T>(error);
        console.log(res2)
        resolve(res2)
      });
    })

  }
  protected static GetFormDataFromModel(model: any) {
    const formData = new FormData();
    Object.keys(model).forEach((k, i) => {

      var d = Object.values(model)[i] as unknown as string;
      if (Array.isArray(d)) {
        var da = d as unknown as any[];
        da.every(i => {
          var name = k;//+"_"+(count++)
          var value = i;
          if (!(value instanceof File)) {
            value = JSON.stringify(da);
            formData.append(name, value)
            return false
          }
          formData.append(name, value)
          return true
        });
      }
      else {
        if (d !== undefined && d !== null) {
          formData.append(k, d || "")
        }

      }

      // Display the key/value pairs
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }

    })

    return formData
  }



  private static ProcessSucessAsync<T>(res: AxiosResponse) {
    let r = res.data as BaseResponseCore<T>;
    r.IsSuccess = (r as any).IsSuccess;
    return r;
  }


  private static ProcessFailureAsync<T>(error: AxiosError) {
    debugger
    let response = new BaseResponseCore<T>({ IsSessionExpired: false, Data: undefined as unknown as T, IsSuccess: false, Errors: [], Message: error.message });
    var errorData = JSON.stringify(error);
    var obj = new ErrorMessage({ AdditionInfo: errorData, ErrorType: ErrorType.Error, Message: error.message });
    response.Errors.push(obj);
    response.Message = error.message;
    return response;
  }



  
}